const messages = {
  en: {
    translations: {
      all: "All",
      none: "None",
      apiKey: {
        title: "Token Manager",
        button: {
          new: "New Token",
          copy: "Copy Token",
          delete: "Delete Token"
        },
        categories: {
          contacts: "Contacts",
          messages: "Messages",
          queues: "Sectors",
          tags: "Tags",
          tickets: "Tickets",
          whatsapp: "WhatsApp",
          whatsappSession: "WhatsApp Sessions",
          activityLogs: "Activity Logs",
          backups: "Backups",
          errorLogs: "Error Logs",
          networkStatus: "Network Monitoring",
          queueMonitor: "Sector Monitoring",
          systemUpdate: "System Update",
          versionWhatsapp: "WhatsApp Version & Library",
          systemResources: "System & Resources",
          videos: "Videos",
          users: "Users",
          quickAnswers: "Quick Answers",
          clientStatus: "Customer Status",
          whatsappGroups: "WhatsApp Groups",
          presence: "Presence (Indicators)",
          authentication: "Authentication"
        },
        permissions: {
          createContacts: "Create Contacts",
          readContacts: "View Contacts",
          updateContacts: "Edit Contacts",
          deleteContacts: "Delete Contacts",
          createMessages: "Send Messages",
          readMessages: "View Messages",
          updateMessages: "Edit Messages",
          deleteMessages: "Delete Messages",
          createQueue: "Create Sectors",
          readQueue: "View Sectors",
          updateQueue: "Edit Sectors",
          deleteQueue: "Delete Sectors",
          createTags: "Create Tags",
          readTags: "View Tags",
          updateTags: "Edit Tags",
          deleteTags: "Delete Tags",
          createTickets: "Create Tickets",
          readTickets: "View Tickets",
          updateTickets: "Edit Tickets",
          deleteTickets: "Delete Tickets",
          createWhatsapp: "Create Connections",
          readWhatsapp: "View Connections",
          updateWhatsapp: "Edit Connections",
          deleteWhatsapp: "Delete Connections",
          createWhatsappSession: "Create Sessions",
          updateWhatsappSession: "Edit Sessions",
          deleteWhatsappSession: "Delete Sessions",
          readActivityLogs: "View Activity Logs",
          createBackups: "Create Backups",
          readBackups: "View Backups",
          updateBackups: "Restore Backups",
          deleteBackups: "Delete Backups",
          createErrorLogs: "Record Error Logs",
          readErrorLogs: "View Error Logs",
          deleteErrorLogs: "Clear Error Logs",
          readNetworkStatus: "View Network Status",
          readQueueMonitor: "View Sector Monitoring",
          readSystemUpdate: "Check System Updates",
          writeSystemUpdate: "Install System Updates",
          readVersion: "View System Version",
          writeWhatsappLib: "Update WhatsApp Library",
          writeSystem: "Restart System Services",
          readSystemResources: "Monitor System Resources",
          readVideos: "View Videos",
          writeVideos: "Manage Videos",
          createUsers: "Create Users",
          readUsers: "View Users",
          updateUsers: "Edit Users",
          deleteUsers: "Delete Users",
          createQuickAnswers: "Create Quick Answers",
          readQuickAnswers: "View Quick Answers",
          updateQuickAnswers: "Edit Quick Answers",
          deleteQuickAnswers: "Delete Quick Answers",
          createClientStatus: "Create Customer Status",
          readClientStatus: "View Customer Status",
          updateClientStatus: "Edit Customer Status",
          deleteClientStatus: "Delete Customer Status",
          readGroups: "View WhatsApp Groups",
          writeGroups: "Manage WhatsApp Groups",
          writePresence: "Send Typing/Recording Indicators",
          readProfile: "Access Profile (Logout)"
        },
        messages: {
          success: {
            copy: "Token copied successfully",
            created: "Token created successfully",
            deleted: "Token deleted successfully"
          },
          error: {
            create: "Error creating token",
            delete: "Error deleting token",
            nameExists: "A token with this name already exists"
          },
          noTokens: "No tokens found"
        },
        modal: {
          title: "Create new token",
          name: "Name",
          permissions: "Permissions",
          permissionsRequired: "Select at least one permission",
          buttons: {
            cancel: "Cancel",
            save: "Save",
            selectAll: "Select All",
            unselectAll: "Deselect All"
          }
        },
        confirmationModal: {
          message: "Are you sure you want to delete this token?",
        },
        table: {
          name: "Name",
          token: "Token",
          permissions: "Permissions",
          created_at: "Created at:",
          actions: "Action"
        }
      },
      apiPage: {
        tokenSelect: {
          label: "API Token",
          placeholder: "Select token",
          noTokens: "Create a new token with the 'create:messages' permission",
          helperText: "Use only a token with 'create:messages' permission"
        },
        form: {
          title: "Send Text or Media Messages",
          phoneLabel: "Phone number",
          phonePlaceholder: "E.g.: 5522999999999",
          messageLabel: "Message body",
          messagePlaceholder: "Type your message here",
          channelLabel: "Channel",
          queueLabel: "Sector",
          userLabel: "User",
          selectFile: "Select File",
          noFile: "No file selected",
          sendButton: "Send Message",
          snippetTitle: "Snippet Generator"
        },
        toasts: {
          noToken: "A valid API token is required to send messages.",
          success: "Message sent successfully!",
          error: "Error sending message:"
        },
        docs: {
          title: "Message sending documentation",
          permissionTag: "Required permission:",
          sendMethods: "Sending Methods",
          textMessages: "Text Messages",
          mediaMessages: "Media Messages",
          instructions: "Instructions",
          importantNotes: "Important Notes",
          tokenNote: "To obtain the API token, go to the API Key section in the sidebar menu. Without this token, sending messages will not be possible.",
          phoneFormat: "The number must be in international format, without special characters:",
          countryCode: "Country code - E.g.: 1 (USA)",
          dddEx: "Area code - E.g.: 22",
          numberEx: "Number - E.g.: 999999999",
          finalFormat: "Final format: 12229999999",
          textTitle: "1. Text Messages",
          textInfo: "Required information for sending text messages:",
          urlLabel: "URL:",
          method: "Method: POST",
          headers: "Headers:",
          jsonBody: "Request body (JSON):",
          requiredParams: "Required parameters:",
          paramNumber: "Recipient number in country code + area code + number format",
          paramBody: "Message content",
          paramUserId: "ID of the user sending the message",
          paramQueueId: "Sector ID",
          paramWhatsappId: "WhatsApp Channel ID (wwebjs)",
          mediaTitle: "2. Media Messages",
          mediaInfo: "Required information for sending media messages:",
          formDataBody: "Request body (FormData):",
          paramBodyMedia: "Message accompanying the media",
          paramMedias: "Media file (image, video, audio, or document)",
          paramUserIdMedia: "ID of the user sending",
          apiResponses: "API Responses:",
          resp200: "Message sent successfully",
          resp401: "Invalid or missing token",
          resp403: "Token does not have 'create:messages' permission",
          resp500: "Internal error!"
        }
      },
      auth: {
        toasts: {
          success: "Login successful!",
          session_expired: "Your session has expired because it was started on another device.",
          user_inactive: "User deactivated. Please contact the administrator."
        },
      },
      backup: {
        title: "Database Backup & Restore",
        refresh: "Refresh",
        nameLabel: "Backup Name",
        namePlaceholder: "Enter a name for the backup",
        create: "Create Backup",
        creating: "Creating...",
        import: "Import Backup",
        importing: "Importing...",
        filename: "Filename",
        size: "Size",
        createdAt: "Created at",
        actions: "Actions",
        noBackups: "No backups found",
        download: "Download",
        restore: "Restore",
        delete: "Delete",
        loadError: "Error loading backups",
        createSuccess: "Backup created successfully!",
        createError: "Error creating backup",
        importSuccess: "Backup imported successfully!",
        importError: "Error importing backup",
        downloadError: "Error downloading backup file",
        deleteSuccess: "Backup deleted successfully!",
        deleteError: "Error deleting backup",
        restoreSuccess: "Backup restored successfully!",
        restoreError: "Error restoring backup",
        confirmDeleteTitle: "Confirm deletion",
        confirmDeleteMessage: "Are you sure you want to delete the backup {{name}}?",
        confirmRestoreTitle: "Confirm restore",
        confirmRestoreMessage: "Are you sure you want to restore the backup {{name}}? This will replace all current data!",
        cancelButton: "Cancel",
        confirmButton: "Confirm"
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      channels: {
        title: "Channels",
        toasts: {
          deleted: "Channel deleted successfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          wwebjs: "Add",
          hub: "Hub",
          shutdown: "Delete Session",
          restart: "Restart",
          disconnect: "Disconnect",
          tryAgain: "Try again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connecting",
          edit: "Edit Channel",
          delete: "Delete Channel",
          start: "Start Session",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content: "Make sure your phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content: "Click the 'QR CODE' button and scan the QR Code with your phone to start the session",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "The connection to the phone was lost",
            content: "Make sure your phone is connected to the internet and WhatsApp is open, or click the 'Disconnect' button to get a new QR Code",
          },
        },
        table: {
          id: "ID",
          channel: "Channel",
          name: "Name",
          color: "Color",
          number: "Number",
          status: "Status",
          lastUpdate: "Last update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      connections: {
        title: "Channels",
        toasts: {
          deleted: "Channel deleted successfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          add: "Add",
          shutdown: "Delete",
          restart: "Restart",
          disconnect: "Disconnect",
          tryAgain: "Try again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connecting",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content: "Make sure your phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content: "Click the 'QR CODE' button and scan the QR Code with your phone to start the session",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "The connection to the phone was lost",
            content: "Make sure your phone is connected to the internet and WhatsApp is open, or click the 'Disconnect' button to get a new QR Code",
          },
        },
        table: {
          id: "ID",
          channel: "Channel",
          name: "Name",
          color: "Color",
          number: "Number",
          status: "Status",
          lastUpdate: "Last update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "WhatsApp Number",
          email: "Email",
          address: "Address",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        numberError: "Invalid WhatsApp number. Please check and try again.",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted successfully!",
          deletedAll: "All contacts deleted successfully!",
          redirectTicket: "You already have an open ticket for this contact. Redirecting...",
          exportSuccess: "Contacts exported successfully!",
          noContactsToExport: "No contacts to export.",
          blocked: "Contact blocked on WhatsApp",
          unblocked: "Contact unblocked on WhatsApp"
        },
        errors: {
          ticketAlreadyOpen: "There is already an open ticket for this contact, assigned to Agent: *{{userName}}* on Channel: *{{userChannel}}* created at: *{{ticketCreatedAt}}*.",
          exportError: "Error exporting contacts."
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          importTitle: "Import contacts",
          deleteMessage: "Are you sure you want to delete this contact? All related tickets will be lost.",
          deleteAllMessage: "Are you sure you want to delete all contacts? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contacts",
          delete: "Delete All Contacts",
          block: "Block",
          unblock: "Unblock"
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          type: "Type",
          address: "Address",
          channels: "Channels",
          actions: "Actions",
        },
        filters: {
          status: "Filter by Status",
          allStatus: "All Statuses"
        },
        exportModal: {
          title: "Select Fields for Export",
          selectAll: "Select All",
          deselectAll: "Deselect All",
          selectedCount: "{{count}} of {{total}} fields selected",
          groups: {
            basic: "Basic Information",
            personal: "Personal Data",
            address: "Address",
            custom: "Custom Fields",
            dates: "Dates"
          },
          fields: {
            id: "ID",
            name: "Name",
            number: "Number",
            email: "Email",
            cpf: "Tax ID",
            birthdate: "Birth Date",
            gender: "Gender",
            status: "Status",
            address: "Address",
            addressNumber: "Number",
            addressComplement: "Complement",
            neighborhood: "Neighborhood",
            city: "City",
            state: "State",
            zip: "ZIP Code",
            country: "Country",
            isGroup: "Is Group",
            profilePicUrl: "Profile Picture",
            extraInfo: "Extra Information",
            tags: "Tags",
            createdAt: "Created At",
            updatedAt: "Updated At",
            lastContactAt: "Last Contact"
          },
          buttons: {
            cancel: "Cancel",
            export: "Export ({{count}} fields)"
          }
        },
        exportProgress: {
          title: "Exporting Contacts",
          preparing: "Preparing export...",
          fetching: "Fetching contacts...",
          processing: "Processing data...",
          finishing: "Finishing..."
        },
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      common: {
        search: "Search",
        selected: "selected",
        cancel: "Cancel",
        confirm: "Confirm",
        refresh: "Refresh",
      },
      groupActions: {
        selectContacts: "Select contacts",
        title: "Group Actions",
        buttons: {
          add: "Add participants",
          remove: "Remove participants",
          promote: "Promote to admin",
          demote: "Demote from admin",
          getInvite: "Copy invite link",
          revokeInvite: "Revoke link",
          subject: "Change title",
          description: "Change description",
          setPicture: "Change photo",
          deletePicture: "Remove photo",
          leave: "Leave group",
          listRequests: "List requests",
          approveRequests: "Approve requests",
          rejectRequests: "Reject requests"
        },
        switches: {
          memberAddMode: "Only admins can add members",
          announcement: "Only admins can send messages",
          restrict: "Only admins can edit info"
        },
        prompts: {
          participantsPlaceholder: "Enter IDs separated by commas (e.g.: 5511999999999@c.us)",
          requestersPlaceholder: "Enter requester IDs (optional, comma-separated)",
          subject: "New group subject:",
          description: "New group description:",
          pictureUrl: "Image URL (will be downloaded and sent as group photo)"
        },
        messages: {
          addOk: "Participants added (or invitation sent).",
          addErr: "Error adding participants.",
          removeOk: "Participants removed.",
          removeErr: "Error removing participants.",
          promoteOk: "Participants promoted to admin.",
          promoteErr: "Error promoting participants.",
          demoteOk: "Participants demoted.",
          demoteErr: "Error demoting participants.",
          inviteCopied: "Invite link copied to clipboard.",
          inviteErr: "Error getting invite link.",
          inviteNone: "Could not get the invite code.",
          inviteRevoked: "New link generated and copied.",
          inviteRevokeErr: "Error revoking invite link.",
          settingsOk: "Settings updated.",
          settingsErr: "Error updating settings.",
          subjectOk: "Subject updated.",
          subjectErr: "Error updating subject.",
          descriptionOk: "Description updated.",
          descriptionErr: "Error updating description.",
          pictureOk: "Group photo updated.",
          pictureErr: "Error updating group photo.",
          pictureDelOk: "Group photo removed.",
          pictureDelErr: "Error removing group photo.",
          leaveOk: "Left the group.",
          leaveErr: "Error leaving group.",
          noRequests: "No pending requests.",
          requestsErr: "Error listing requests.",
          requestsApproveOk: "Requests approved.",
          requestsApproveErr: "Error approving requests.",
          requestsRejectOk: "Requests rejected.",
          requestsRejectErr: "Error rejecting requests."
        },
        modals: {
          subjectTitle: "Change Group Name",
          subjectLabel: "Group name",
          descriptionTitle: "Change Group Description",
          descriptionLabel: "Group description",
          removeTitle: "Remove Participants",
          promoteTitle: "Promote to Admin",
          demoteTitle: "Demote from Admin",
          owner: "Owner",
          admin: "Admin",
          noMembers: "No members found",
          save: "Save",
          cancel: "Cancel",
        }
      },
      copyToClipboard: {
        copy: "Copy",
        copied: "Copied"
      },
      cpuUsage: {
        title: "CPU Usage",
        infoIcon: "System CPU",
        modelCPU: "Model",
        cores: "Cores",
        threads: "Threads",
        frequency: "Frequency",
        uptime: "Uptime",
        topProcesses: "Top CPU-Consuming Processes",
        pid: "PID",
        process: "Process",
        user: "User",
        cpuUsage: "CPU Usage",
        cpuTime: "CPU Time",
        noProcessesFound: "No processes found",
      },
      dashboard: {
        messages: {
          inAttendance: {
            title: "In Attendance"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          },
          sent: {
            title: "Messages Sent",
            titleAdmin: "Total Messages Sent"
          },
          received: {
            title: "Messages Received",
            titleAdmin: "Total Messages Received"
          }
        },
        charts: {
          perDay: {
            title: "Tickets per period: ",
          },
          date: {
            start: "Start date",
            end: "End date"
          },
          perConnection: {
            date: {
              start: "Start date",
              end: "End date"
            },
            perConnection: {
              title: "Tickets by Channel"
            }
          },
          perQueue: {
            title: "Tickets by Sector",
            date: {
              start: "Start date",
              end: "End date"
            },
          },
        },
        chartPerUser: {
          title: "Tickets by user",
          ticket: "Ticket",
          date: {
            start: "Start date",
            end: "End date"
          },
        },
        chartPerConnection: {
          date: {
            start: "Start date",
            end: "End date"
          },
          perConnection: {
            title: "Tickets by Channel"
          }
        },
        chartPerQueue: {
          date: {
            start: "Start date",
            end: "End date"
          },
          perQueue: {
            title: "Tickets by Sector"
          }
        },
        ChartMessages: {
          title: "Messages by User",
          noUser: "No User",
          messages: {
            sent: "Sent",
            received: "Received"
          },
          date: {
            start: "Start date",
            end: "End date"
          }
        },
        newContacts: {
          contact: "Contacts",
          date: {
            start: "Start date",
            end: "End date"
          },
          title: "New contacts per day"
        },
        contactsWithTickets: {
          message: "No contact found for this date.",
          unique: "Unique contact",
          date: {
            start: "Start date",
            end: "End date"
          },
          title: "Contacts who opened tickets in the period"
        },
        tags: {
          cloudTitle: "Tags: ",
          noTags: "No tags at the moment!"
        },
        users: {
          title: "Online Users"
        },
        clientStatus: {
          pieChart: {
            title: "Contact Distribution by Status"
          },
          barChart: {
            title: "Contact Count by Status"
          },
          withoutStatus: "No Status",
          totalContacts: "Total Contacts",
          withStatusLabel: "With Status",
          withoutStatusLabel: "Without Status",
          contactsCount: "Contact Count",
          loading: "Loading statistics...",
          noData: "No data available"
        },
      },
      diskSpace: {
        title: "Disk Space",
        systemFolder: "System Folder",
        used: "used",
        healthy: "Healthy",
        warning: "Warning",
        critical: "Critical",
        folderSize: "Folder Size",
        freeSpace: "Free Space",
        totalSpace: "Total Space",
        criticalWarning: "Warning: Disk space is in a critical state. We recommend freeing space immediately to prevent system issues.",
        warningMessage: "Warning: Disk space is running low. Consider freeing space to prevent future issues.",
        folders: "Folders",
        folderName: "Name",
        size: "Size",
        percentage: "Percentage",
        noFoldersFound: "No folders found",
      },
      memoryUsage: {
        title: "RAM Memory Usage",
        systemMemory: "System Memory",
        used: "used",
        healthy: "Healthy",
        warning: "Warning",
        critical: "Critical",
        totalMemory: "Total Memory",
        usedMemory: "Used Memory",
        freeMemory: "Free Memory",
        cachedMemory: "Cached Memory",
        availableMemory: "Available Memory",
        criticalWarning: "Warning: RAM usage is in a critical state. We recommend restarting some services or the system to prevent issues.",
        warningMessage: "Warning: RAM usage is high. Monitor the system to prevent performance issues.",
        topProcesses: "Top Memory-Consuming Processes",
        pid: "PID",
        process: "Process",
        memoryUsage: "Memory Usage",
        percentage: "Percentage",
        noProcesses: "No processes found."
      },
      errorLogs: {
        title: "Error Log",
        searchPlaceholder: "Search by error message...",
        loading: "Loading logs...",
        noRecords: "No logs found.",
        table: {
          id: "ID",
          date: "Date",
          source: "Source",
          severity: "Severity",
          message: "Message",
          actions: "Actions"
        },
        logDetails: {
          title: "Log Details",
          date: "Date",
          source: "Source",
          severity: "Severity",
          component: "Component",
          userId: "User ID",
          user: "User Name",
          url: "URL",
          message: "Message",
          stack: "Stack Trace",
          userAgent: "Browser"
        },
        filter: {
          title: "Filters",
          source: "Source",
          severity: "Severity",
          startDate: "Start Date",
          endDate: "End Date",
          all: "All"
        },
        deleteDialog: {
          title: "Remove Old Logs",
          message: "This action will remove all logs older than 30 days. This action cannot be undone. Do you want to continue?"
        },
        pagination: {
          rowsPerPage: "Rows per page",
          of: "of"
        },
        buttons: {
          search: "Search",
          filter: "Filter",
          refresh: "Refresh",
          download: "Download",
          deleteOld: "Remove Old",
          close: "Close",
          clearFilters: "Clear Filters",
          cancel: "Cancel",
          applyFilters: "Apply Filters",
          confirm: "Confirm"
        }
      },
      forgotPassword: {
        title: "Forgot Password?",
        form: {
          email: "Enter your email"
        },
        buttons: {
          submit: "Send Reset Link",
          backToLogin: "Back to Login"
        },
        success: "If a valid email was found, a password reset link has been sent!",
        error: {
          invalidEmail: "Please enter a valid email.",
          generic: "Error requesting password reset. Try again later."
        }
      },
      integrations: {
        success: "Integration saved successfully.",
        title: "Integrations",
        integrations: {
          openai: {
            title: "OpenAI",
            organization: "Organization ID",
            apikey: "KEY"
          },
          n8n: {
            title: "N8N",
            urlApiN8N: "API URL N8N"
          },
          hub: {
            title: "Notificame Hub",
            hubToken: "Token"
          },
          maps: {
            title: "Google Maps API",
            apiMaps: "API Key"
          }
        },
      },
      languageSelector: {
        title: "Select language"
      },
      locationPreview: {
        title: "Location received",
        alt: "Location",
        latitude: "Latitude",
        longitude: "Longitude",
        buttons: {
          view: "VIEW"
        },
        noCoordinates: "Coordinates not available"
      },
      multiVcardPreview: {
        title: "Contacts received",
        viewAll: "View all {{count}} contacts"
      },
      vcardPreview: {
        chat: "CHAT",
        mobile: "Mobile",
        number: "Number",
        contactName: "Contact Name",
        numberNotAvailable: "Number not available",
        selectNumberTitle: "Select a number to chat",
        whatsappNumber: "WhatsApp Number",
        phoneNumber: "Phone number",
        cancel: "Cancel"
      },
      login: {
        title: "Login now",
        form: {
          email: "Enter your email",
          password: "Enter your password",
        },
        buttons: {
          forgotPassword: "Forgot Password?",
          submit: "Login",
          register: "Don't have an account? Sign up!",
        },
      },
      mainDrawer: {
        listItems: {
          general: "General",
          administration: "Administration",
          apititle: "API",
          videos: "Tutorial Videos",
          api: "API Usage",
          apidocs: "API Documentation",
          apikey: "API Manager",
          tickets: "Tickets",
          contacts: "Contacts",
          blockedContacts: "Blocked Contacts",
          dashboard: "Dashboard",
          quickAnswers: "Quick Answers",
          tags: "Tags",
          clientStatus: "Customer Status",
          channels: "Channels",
          queues: "Sectors",
          users: "Agents",
          groups: "Groups",
          settings: "Settings",
          system: "System Monitoring",
          errorLogs: "Error Log",
          diskSpace: "Disk Space",
          maintenance: "System Maintenance",
          memoryUsage: "RAM Memory Usage",
          cpuUsage: "CPU Usage",
          databaseStatus: "Database",
          backup: "Database Backup & Restore",
          activityLogs: "Activity Logs",
          networkStatus: "Network Status",
          queueMonitor: "Sector Monitoring",
          userMonitor: "User Monitoring",
          systemHealth: "Channel Monitoring",
          systemUpdate: "System Updates",
          versionCheck: "Library Check",
          logout: "Logout",
        },
        appBar: {
          message: {
            hi: "Hello",
            text: "Welcome to the System"
          },
          user: {
            profile: "Profile",
            logout: "Logout",
          },
          fullscreen: {
            enter: "Fullscreen",
            exit: "Exit fullscreen"
          },
        },
      },
      messageOptionsMenu: {
        react: "React (beta)",
        edit: "Edit",
        history: "History",
        delete: "Delete",
        reply: "Reply",
        copy: "Copy",
        forward: "Forward (beta)",
        copied: "Message copied!",
        copyError: "Error copying message",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      forwardMessages: {
        title: "Forward messages to",
        searchPlaceholder: "Search name or number",
        selectedCount: "selected",
        selectedCountPlural: "selected",
        forwardButton: "Forward",
        cancel: "Cancel",
        selectMode: "Select messages",
        exitSelectMode: "Exit",
        noMessagesSelected: "No messages selected",
        forwarded: "Forwarded",
        forwardedSuccess: "Messages forwarded successfully!",
        forwardedError: "Error forwarding messages",
      },
      healthCheck: {
        title: "Channel Monitoring",
        tooltips: {
          refresh: "Refresh"
        },
        noChannels: "No channels found",
        number: "Number",
        pushname: "User",
        platform: "Platform",
        wwebVersion: "Version",
        uptime: "Uptime",
        messages: "Messages",
        latency: "Latency",
        errors: "Errors",
        lastActivity: "Last activity",
        connectionStatus: "Connection Status"
      },
      messageHistoryModal: {
        close: "Close",
        title: "Message edit history"
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          queue: "Sector",
          channel: "Channel",
          noAssignedUser: "None",
          noChannel: "None",
          noQueue: "None",
          buttons: {
            return: "Return",
            resolve: "Close",
            reopen: "Reopen",
            accept: "Accept",
            options: "Options"
          },
        },
        message: {
          notCompatibleWithSystem: "You received a message that is currently not compatible with the system.",
          viewOnMobile: "To view the full content, access the app on your phone.",
          type: "Message type",
          download: "Download",
          ticketNumber: "#ticket:",
          voiceVideoLost: "Voice or video message lost at",
          deleted: "Message deleted",
          edited: "Edited",
          today: "Today",
          yesterday: "Yesterday"
        }
      },
      messagesInput: {
        placeholderOpen: "Type a message",
        placeholderClosed: "This ticket is closed!",
        placeholderBlocked: "Contact is blocked. Unblock to send messages.",
        signMessage: "Sign",
        btnSend: "Send",
        btnUploadFile: "Send media",
        btnRecord: "Record audio",
        tooManyFiles: "Maximum number of files exceeded. Max: ",
        dropFilesHere: "Drop files here",
        buttons: {
          emoji: "Add emoji",
          attach: "Attach file",
          record: "Record audio",
          send: "Send message"
        },
        clearReply: "Clear reply"
      },
      attachmentMenu: {
        document: "Document",
        documentDesc: "PDF, DOC, TXT and others",
        photoVideo: "Photos & videos",
        photoVideoDesc: "Images and videos from gallery",
        camera: "Camera (beta)",
        cameraDesc: "Take photo or record video",
        audio: "Audio",
        audioDesc: "MP3, WAV and other audio files",
        contact: "Contact (beta)",
        contactDesc: "Share contact"
      },
      messageVariablesPicker: {
        label: "Available variables",
        vars: {
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket ID",
          queue: "Sector",
          connection: "Channel"
        }
      },
      modalImageContact: {
        alt: "Contact image",
        toolBar: {
          rotateLeft: "Rotate left",
          rotateRight: "Rotate right",
          zoomIn: "Zoom in",
          zoomOut: "Zoom out",
          resetZoom: "Reset zoom",
          fullscreen: "Fullscreen",
          fullscreenExit: "Exit fullscreen",
          copyLink: "Copy link",
          download: "Download image"
        },
        snackbar: {
          copyLinkSuccess: "Link copied successfully!",
          copyLinkError: "Error copying link. Please try again.",
        }
      },
      modalImageCors: {
        alt: "Contact image",
        error: {
          loadImage: "Error loading image"
        },
        navigation: {
          previous: "Previous image",
          next: "Next image"
        },
        button: {
          applyCrop: "Apply",
          cancelCrop: "Cancel"
        },
        dragToCrop: "Drag to select the crop area",
        toolBar: {
          rotateLeft: "Rotate left",
          rotateRight: "Rotate right",
          zoomIn: "Zoom in",
          zoomOut: "Zoom out",
          resetZoom: "Reset zoom",
          fullscreen: "Fullscreen",
          exitFullscreen: "Exit fullscreen",
          copyLink: "Copy link",
          download: "Download image",
          cancelCrop: "Cancel crop",
          cropImage: "Crop image",
          disableCompare: "Disable comparison",
          compareImages: "Compare images",
          downloadImage: "Download image"
        },
        snackbar: {
          copyLinkSuccess: "Link copied successfully!",
          copyLinkError: "Error copying link. Please try again.",
          cropSuccess: "Image cropped successfully!",
          cropError: "Error cropping image. Please try again."
        }
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for the contact",
        add: "Add",
        select: {
          none: "Select",
          queue: "Select Sector",
          channel: "Select Channel"
        },
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      newTicketModalContactPage: {
        title: "Create Ticket",
        queue: "Select a Sector",
        fieldLabel: "Type to search for the contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      notifications: {
        allow: "Allow browser notifications?",
        noTickets: "No notifications.",
        permissionGranted: "Permission granted.",
        permissionDenied: "Permission denied.",
      },
      qrCode: {
        message: "Scan the QR Code to start the session",
      },
      queueModal: {
        title: {
          add: "Add Sector",
          edit: "Edit Sector",
        },
        notification: {
          title: "Sector saved successfully!",
        },
        validation: {
          tooShort: "Too short",
          tooLong: "Too long",
          requiredName: "Sector name is required",
          requiredColor: "Sector color is required",
        },
        form: {
          name: "Name",
          namePlaceholder: "Enter sector name",
          color: "Color",
          colorTooltip: "Current sector color",
          selectColor: "Select color",
          greetingMessage: "Greeting message",
          greetingMessagePlaceholder: "Enter the message to be sent when the customer is served in this sector",
          startWork: "Opening",
          endWork: "Closing",
          absenceMessage: "Absence message",
          absenceMessagePlaceholder: "Enter the message to be sent when the sector is closed",
          breakTitle: "Break Schedule",
          startBreak: "Break start",
          endBreak: "Break end",
          breakMessage: "Break message",
          breakMessagePlaceholder: "Enter the message to be sent when the sector is on break",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      queues: {
        title: "Sectors",
        notifications: {
          queueDeleted: "The sector has been deleted.",
        },
        table: {
          id: "ID",
          name: "Name",
          color: "Color",
          greeting: "View messages",
          workHours: "Working Hours",
          actions: "Actions",
          startWork: "Opening",
          endWork: "Closing",
          edit: "Edit",
          delete: "Delete",
        },
        buttons: {
          add: "Add sector",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone! Tickets in this sector will remain but will not have a sector assigned anymore.",
        },
        messagesModal: {
          title: "Messages",
          greetingMessage: "Greeting Message",
          absenceMessage: "Absence Message",
          none: "No message",
          btnClose: "Close",
        },
        timeModal: {
          title: "Working Hours",
          notSet: "Not defined",
          btnClose: "Close",
        }
      },
      queueSelect: {
        inputLabel: "Sectors",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Answer",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Answer",
          deleteAll: "Delete All Quick Answers",
        },
        toasts: {
          deleted: "Quick Answer deleted successfully.",
          deletedAll: "All Quick Answers deleted.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Answer: ",
          deleteAllTitle: "Are you sure you want to delete all Quick Answers?",
          deleteMessage: "This action cannot be undone.",
          deleteAllMessage: "This action cannot be undone.",
        },
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Answer",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Answer",
        },
        variables: "Available variables",
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Answer saved successfully.",
      },
      resetPassword: {
        title: "Reset Password",
        form: {
          password: "New Password",
          confirmPassword: "Confirm New Password"
        },
        buttons: {
          submit: "Reset Password",
          backToLogin: "Back to Login"
        },
        success: "Password reset successfully!",
        error: {
          passwordMismatch: "Passwords do not match.",
          generic: "Error resetting password. Try again."
        }
      },
      settings: {
        title: "Settings",
        success: "Settings saved successfully.",
        tabs: {
          general: "General",
          personalize: "Personalize",
          integrations: "Integrations",
          company: "Company"
        },
        general: {
          ticketManagement: "Ticket Management",
          userInterface: "User Interface",
          systemBehavior: "System Behavior",
          timeSettings: "Time Settings",
          userCreation: {
            name: "User creation",
            note: "Allow user creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          allTicket: {
            name: "Everyone can see tickets without sectors",
            note: "Enable this feature to let all users see tickets without sectors",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          CheckMsgIsGroup: {
            name: "Ignore Group Messages",
            note: "If disabled, you will receive messages from groups.",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          call: {
            name: "Reject calls",
            note: "If enabled, the customer will receive a message stating that calls are not accepted",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          autoRejectCalls: {
            name: "Auto-Reject Calls (beta)",
            note: "Automatically rejects all incoming calls (voice and video) and sends a configurable message",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          autoRejectCallsMessage: {
            name: "Call Rejection Message",
            note: "Message sent automatically after rejecting a call",
            placeholder: "Enter the message to be sent when a call is rejected...",
          },
          callSettings: "Call Settings",
          sideMenu: {
            name: "Initial Side Menu",
            note: "If enabled, the side menu will start closed",
            options: {
              enabled: "Open",
              disabled: "Closed",
            },
          },
          quickAnswer: {
            name: "Quick Answers",
            note: "If enabled, quick answers can be edited",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          closeTicketApi: {
            name: "Close Ticket sent via API",
            note: "Automatically closes the ticket when sent via API",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          darkMode: {
            name: "Enable Dark Mode",
            note: "Switch between light and dark mode",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          ASC: {
            name: "Ticket Sorting (ASC or DESC)",
            note: "When enabled, it will sort ascending (ASC), disabling will sort descending (DESC)",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          created: {
            name: "Ticket Sorting (createdAt or updateAt)",
            note: "When enabled, it will sort by creation date (createdAt), disabling will sort by update date (updateAt)",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          openTickets: {
            name: "Prevent multi-tickets for the same contact",
            note: "When enabled, it will prevent opening tickets for contacts who already have an open ticket",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          signOption: {
            name: "Message Signature",
            note: "Enable this feature to allow users to disable message signature",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabsPending: {
            name: "Show pending tabs",
            note: "Disable this feature to hide the pending tabs",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabsClosed: {
            name: "Show closed tabs",
            note: "Disable this feature to hide the closed tabs",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          listItemSpy: {
            name: "Show spy button",
            note: "If enabled, the spy button will be shown on the tickets list",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          queueLength: {
            name: "Allow sending channel greeting with 1 Sector",
            note: "If enabled, allows sending the channel greeting message with only 1 sector",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            }
          },
          timeCreateNewTicket: {
            name: "New Ticket in:",
            note: "Select the time required to open a new ticket if the customer contacts again",
            options: {
              "10": "10 Seconds",
              "30": "30 Seconds",
              "60": "1 minute",
              "300": "5 minutes",
              "1800": "30 minutes",
              "3600": "1 hour",
              "7200": "2 hours",
              "21600": "6 hours",
              "43200": "12 hours",
              "86400": "24 hours",
              "604800": "7 days",
              "1296000": "15 days",
              "2592000": "30 days",
            },
          },
          sessionTimeout: {
            name: "Session inactivity timeout:",
            note: "Sets how long before an inactive user is automatically logged out",
            options: {
              "1": "1 hour",
              "2": "2 hours",
              "4": "4 hours",
              "6": "6 hours",
              "8": "8 hours (default)",
              "12": "12 hours",
              "24": "24 hours",
              "48": "48 hours",
              "72": "3 days",
              "168": "7 days",
            },
          },
        },
        personalize: {
          success: {
            company: "Company data saved successfully!",
            logos: "Logos saved successfully!",
            colors: "Colors saved successfully!",
          },
          error: {
            invalid: "Error fetching customizations.",
            company: "Error saving company data.",
            logos: "Error saving the logo.",
            logs: "Error saving customization:",
            colors: "Error saving theme colors: "
          },
          tabs: {
            company: "Company",
            logos: "Logos",
            colors: "Colors",
          },
          tabpanel: {
            companyInfo: "Company Information",
            company: "Company Name",
            url: "URL",
            light: "Light Theme",
            dark: "Dark Theme",
            input: {
              primary: "Primary Color",
              secondary: "Secondary Color",
              default: "Background Default",
              paper: "Background Paper",
            },
            button: {
              save: "Save",
              saveLight: "Save light theme",
              saveDark: "Save dark theme",
            }
          },
        }
      },
      sessionExpiredModal: {
        title: "Session Expired Due to Inactivity",
        message: "Your session was automatically ended because it exceeded the configured inactivity timeout. Click confirm to be redirected to the login screen.",
        confirm: "Confirm",
      },
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Log in now!",
          fail: "Error creating user. Check the entered data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Sign up",
          login: "Already have an account? Log in!",
        },
      },
      tags: {
        title: "Tags",
        table: {
          id: "ID",
          name: "Tags",
          color: "Color",
          contacts: "Contacts",
          actions: "Action"
        },
        toasts: {
          deleted: "Tag deleted successfully!",
          deletedAll: "All Tags deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
          viewContacts: "View contacts with this tag"
        },
        confirmationModal: {
          deleteTitle: "Delete ",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this Tag?",
          deleteAllMessage: "Are you sure you want to delete all Tags?",
        },
      },
      tagModal: {
        title: {
          add: "Add Tag",
          edit: "Edit Tag",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
        },
        form: {
          name: "Tag Name",
          color: "Tag Color"
        },
        success: "Tag saved successfully!",
      },
      clientStatus: {
        title: "Customer Status",
        table: {
          id: "ID",
          name: "Status",
          color: "Color",
          contacts: "Contacts",
          actions: "Action"
        },
        toasts: {
          deleted: "Status deleted successfully!",
          deletedAll: "All statuses deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
          viewContacts: "View contacts with this status"
        },
        confirmationModal: {
          deleteTitle: "Delete ",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this Status?",
          deleteAllMessage: "Are you sure you want to delete all Statuses?",
        },
      },
      clientStatusModal: {
        title: {
          add: "Add Status",
          edit: "Edit Status",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
        },
        form: {
          name: "Status Name",
          color: "Status Color"
        },
        success: "Status saved successfully!",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New Ticket",
          closed: "Close",
          refresh: "Refresh"
        },
        menu: {
          all: "All Tickets",
          open: "All In Attendance",
          pending: "All Waiting",
          groups: "All Groups"
        },
        confirmationModal: {
          closeAllTitle: "Close All Tickets",
          closeOpenTitle: "Close In Attendance Tickets",
          closePendingTitle: "Close Waiting Tickets",
          closeGroupsTitle: "Close All Groups",
          closeAllMessage: "Are you sure you want to close all Tickets?",
          closeOpenMessage: "Are you sure you want to close all In Attendance Tickets (individual)?",
          closePendingMessage: "Are you sure you want to close all Waiting Tickets?",
          closeGroupsMessage: "Are you sure you want to close all In Attendance Groups?"
        }
      },
      ticketsQueueSelect: {
        placeholder: "Sectors",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were in has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        notifications: {
          closed: {
            success: "Tickets closed successfully!",
            error: "Error closing tickets. Please try again.",
            tickets: "tickets closed"
          }
        },
        tabs: {
          open: { title: "In Attendance" },
          groups: { title: "Groups" },
          pending: { title: "Waiting" },
          closed: { title: "Closed" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages",
        },
        buttons: {
          showAll: "All",
          queues: "Sectors"
        },
        confirmationModal: {
          closeTicket: {
              title: "Close Ticket",
              message: "Are you sure you want to close this ticket?",
          },
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Enter to search for an agent",
        fieldConnectionLabel: "Select Channel",
        fieldQueueLabel: "Transfer to Sector",
        fieldConnectionPlaceholder: "Select a Channel",
        noOptions: "No agent found with that name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Waiting",
        assignedHeader: "In Attendance",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term",
        connectionTitle: "Currently used channel.",
        items: {
          queueless: "No Sector",
          accept: "Accept",
          spy: "Spy",
          close: "Close",
          reopen: "Reopen",
          return: "Move to waiting",
          connection: "Channel",
          user: "Agent",
          queue: "Sector",
          tags: "Tags",
          ticket: "Ticket ID"
        },
        buttons: {
          accept: "Respond",
          acceptBeforeBot: "Accept",
          start: "Start",
          cancel: "Cancel"
        },
        acceptModal: {
          title: "Accept Ticket",
          queue: "Sectors",
          selectQueue: "Select a sector"
        },
        errors: {
          ticketAlreadyOpen: "There is already an open ticket for this contact, assigned to Agent: *{{userName}}* on Channel: *{{userChannel}}* created at: *{{ticketCreatedAt}}*."
        }
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete the ticket ",
          titleFrom: "from contact ",
          message: "Warning! All messages related to the ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "DRAG AND DROP FILES HERE",
          titleFileList: "File list"
        }
      },
      uploadModal: {
        title: "Send files",
        caption: "Caption",
        captionPlaceholder: "Add a caption (optional)",
        send: "Send",
        cancel: "Cancel",
        remove: "Remove file",
        pdfError: "Could not load the PDF. Please download the file."
      },
      users: {
        title: "Agents",
        searchPlaceholder: "Search...",
        status: {
          online: "Online",
          offline: "Offline"
        },
        table: {
          id: "ID",
          name: "Name",
          status: "Status",
          email: "Email",
          profile: "Profile",
          whatsapp: "Channel",
          queue: "Sector",
          startWork: "Start time",
          endWork: "End time",
          schedule: "Schedule",
          actions: "Actions",
          viewChannels: "View Channels",
          viewQueues: "View Sectors",
          viewSchedule: "View Schedule"
        },
        schedule: {
          title: "Working Hours",
          opening: "Opening",
          closing: "Closing",
        },
        buttons: {
          add: "Add agent",
          close: "Close"
        },
        modalTitle: {
          channel: "Channels",
          queue: "Sectors"
        },
        modalTable: {
          id: "ID",
          name: "Name",
          type: "Type",
        },
        toasts: {
          deleted: "Agent successfully deleted.",
          updated: "Agent successfully updated."
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "All data for this agent will be lost. Tickets opened by this agent will be moved to pending.",
        },
        actions: {
          activate: "Activate user",
          deactivate: "Deactivate user",
          edit: "Edit",
          delete: "Delete",
        }
      },
      userModal: {
        title: {
          add: "Add agent",
          edit: "Edit agent",
        },
        form: {
          name: "Name",
          namePlaceholder: "Enter agent name",
          email: "Email",
          emailPlaceholder: "Enter agent email",
          password: "Password",
          passwordPlaceholder: "Enter agent password",
          toggleVisibility: "Show/hide password",
          profile: "Profile",
          admin: "Administrator",
          user: "Agent",
          startWork: "Start",
          endWork: "End",
          isTricked: "View Contacts",
          enabled: "Enabled",
          disabled: "Disabled"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Agent saved successfully.",
      },
      notificameHubModal: {
        title: "Activate NotificameHub Channels",
        form: {
          name: "Name",
          namePlaceholder: "Enter connection name",
          channelSelection: "Channel Selection",
          selectChannel: "Select Channel",
          selectChannelPlaceholder: "Select a channel",
          mainInfo: "Main Information"
        },
        integration: {
          title: "Channel Integration",
          description: "To activate <strong>Facebook</strong>, <strong>Instagram</strong>, <strong>Telegram</strong>, and <strong>WebChat</strong>, sign up using the button below, then acquire the desired channels using the coupon below. Enter your <strong>Account</strong> token on the Integrations page to finalize the integration.",
          discount: "Use the coupon below to get each channel for <strong>$10.00</strong>!",
          copied: "Copied!",
          copy: "Copy coupon",
          register: "SIGN UP HERE"
        },
        buttons: {
          add: "Add",
          cancel: "Cancel"
        },
        success: "Channel activated successfully."
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          namePlaceholder: "Enter connection name",
          default: "Default",
          display: "Show sector schedules",
          farewellMessage: "Farewell message",
          farewellMessagePlaceholder: "This message will be sent before closing the ticket",
          greetingMessagePlaceholder: "This message will be sent when the customer starts a conversation",
          color: "Color",
          channels: "Activate Channels",
          mainInfo: "Main Information",
          messagesTitle: "Messages",
          appearanceTitle: "Appearance",
          queuesTitle: "Sectors",
          channelSelection: "Channel Selection",
          selectChannel: "Select Channel",
          selectChannelPlaceholder: "Select a channel"
        },
        integration: {
          title: "Channel Integration",
          description: "To activate <strong>Facebook</strong>, <strong>Instagram</strong>, <strong>Telegram</strong>, and <strong>WebChat</strong>, sign up using the button below, then acquire the desired channels using the coupon below. Enter your <strong>Account</strong> token on the Integrations page to finalize the integration.",
          discount: "Use the coupon below for <strong>50% off</strong> channel purchases!",
          copied: "Copied!",
          copy: "Copy coupon",
          register: "SIGN UP HERE"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      whatsappSelect: {
        inputLabel: "Channels",
      },
      databaseStatus: {
        title: "Database Monitoring",
        refresh: "Refresh",
        fetchError: "Error loading database data",
        generalInfo: "General Information",
        dbName: "Database Name",
        status: "Status",
        online: "Online",
        offline: "Offline",
        host: "Host",
        port: "Port",
        dialect: "Dialect",
        totalSize: "Total Size",
        performance: "Performance",
        uptime: "Uptime",
        activeConnections: "Active Connections",
        totalConnections: "Total Connections",
        totalQueries: "Total Queries",
        slowQueries: "Slow Queries",
        dbTables: "Database Tables",
        tableName: "Table Name",
        rows: "Rows",
        dataSize: "Data Size",
        indexSize: "Index Size",
        noTables: "No tables found",
        slowQueriesTitle: "Slow Queries (last 24h)",
        startTime: "Start Time",
        database: "Database",
        queryTime: "Query Time",
        rowsExamined: "Rows Examined",
        sql: "SQL",
        noSlowQueries: "No slow queries found",
        activeProcesses: "Active Processes",
        id: "ID",
        user: "User",
        command: "Command",
        time: "Time (s)",
        state: "State",
        query: "Query",
        noQuery: "No query",
        noActiveProcesses: "No active processes found"
      },
      videos: {
        title: "Tutorial Videos",
        searchPlaceholder: "Search by title...",
        loading: "Loading videos...",
        noRecords: "No videos found.",
        table: {
          title: "Title",
          status: "Status",
          visibility: "Visibility",
          actions: "Actions"
        },
        active: "Active",
        inactive: "Inactive",
        allUsers: "All users",
        buttons: {
          add: "Add Video",
          edit: "Edit",
          delete: "Delete",
          cards: "View Cards",
          table: "View Table",
          save: "Save",
          cancel: "Cancel"
        },
        dialog: {
          add: "Add Video",
          edit: "Edit Video",
          title: "Title",
          url: "YouTube URL",
          urlHelp: "Enter the full YouTube video URL",
          active: "Active",
          users: "Users who can view",
          usersHelp: "If no user is selected, all users can view the video",
          preview: "Preview"
        },
        toasts: {
          added: "Video added successfully!",
          updated: "Video updated successfully!",
          deleted: "Video deleted successfully!",
          required: "Please fill in all required fields.",
          invalidUrl: "Invalid video URL!",
        },
        confirmationModal: {
          deleteTitle: "Delete Video",
          deleteMessage: "Are you sure you want to delete this video? This action cannot be undone."
        }
      },
      systemHealth: {
        title: "System Health Dashboard",
        refresh: "Refresh",
        refreshSuccess: "Data refreshed successfully!",
        overallStatus: "Overall System Status",
        statusHealthy: "Healthy",
        statusWarning: "Warning",
        statusCritical: "Critical",
        statusLoading: "Loading...",
        uptime: "Uptime",
        activeUsers: "Active Users",
        openTickets: "Open Tickets",
        messagesLast24h: "Messages (24h)",
        alerts: "Alerts",
        cpu: "CPU",
        memory: "Memory",
        disk: "Disk",
        database: "Database",
        whatsapp: "WhatsApp",
        application: "Application",
        usage: "Usage",
        cores: "Cores",
        model: "Model",
        loadAvg: "Load Average",
        total: "Total",
        used: "Used",
        free: "Free",
        status: "Status",
        connected: "Connected",
        error: "Error",
        responseTime: "Response Time",
        activeConnections: "Active Connections",
        version: "Version",
        totalConnections: "Total Connections",
        connectedWhatsapps: "Connected WhatsApps",
        disconnectedWhatsapps: "Disconnected WhatsApps",
        pendingMessages: "Pending Messages",
        nodeVersion: "Node.js Version",
        pendingTickets: "Pending Tickets",
        errors: "Errors",
        checkConnections: "Check Connections",
        databaseStatus: "Database Status",
        databaseResponseTime: "Database Response Time",
        databaseConnections: "Database Connections",
        whatsappStatus: "WhatsApp Connection Status",
        applicationStatus: "Application Status",
        systemStatus: "System Status",
        healthySystem: "System Healthy",
        warningSystem: "System with Alerts",
        criticalSystem: "System in Critical State"
      },
      queueMonitor: {
        title: "Sector Monitoring",
        refresh: "Refresh",
        refreshSuccess: "Data refreshed successfully!",
        summary: "Summary",
        totalTickets: "Total Tickets",
        waitingTickets: "Waiting Tickets",
        avgWaitTime: "Average Wait Time",
        messagesLast24Hours: "Messages (24h)",
        whatsappConnections: "Channels",
        name: "Name",
        type: "Type",
        status: "Status",
        queues: "Sectors",
        pendingMessages: "Pending Messages",
        users: "Users",
        pendingTickets: "Pending Tickets",
        activeTickets: "Active Tickets",
        avgHandleTime: "Average Handle Time",
        oldestTicket: "Oldest Ticket",
        totalMessages: "Total Messages",
        last24Hours: "Last 24 Hours",
        last7Days: "Last 7 Days",
        today: "Today",
        connected: "Connected",
        disconnected: "Disconnected",
        loading: "Loading...",
        justNow: "Just now",
        minutesAgo: "{{minutes}} minute(s) ago",
        hoursAgo: "{{hours}} hour(s) ago",
        daysAgo: "{{days}} day(s) ago"
      },
      userMonitor: {
        title: "User Monitoring",
        refresh: "Refresh",
        refreshSuccess: "Data refreshed successfully!",
        selectUser: "Select User",
        allUsers: "All Users",
        summary: "General Summary",
        totalUsers: "Total Users",
        usersOnline: "Users Online",
        usersOffline: "Users Offline",
        totalTickets: "Total Tickets",
        totalMessages: "Total Messages",
        avgResponseTime: "Average Response Time",
        avgResolutionRate: "Average Resolution Rate",
        user: "User",
        profile: "Profile",
        status: "Status",
        online: "Online",
        offline: "Offline",
        queues: "Sectors",
        tickets: "Tickets",
        messages: "Messages",
        resolutionRate: "Resolution Rate",
        lastActivity: "Last Activity",
        detailedStats: "Detailed Statistics",
        ticketsByUser: "Tickets by User",
        messagesByUser: "Messages by User",
        performanceMetrics: "Performance Metrics",
        userStatus: "User Status",
        open: "Open",
        pending: "Pending",
        closed: "Closed",
        total: "Total",
        today: "Today",
        last7Days: "Last 7 Days",
        responseTime: "Response Time",
        handleTime: "Handle Time",
        justNow: "Just now",
        minutesAgo: "{{minutes}} minute(s) ago",
        hoursAgo: "{{hours}} hour(s) ago",
        daysAgo: "{{days}} day(s) ago",
        profiles: {
          admin: "Administrator",
          user: "User"
        }
      },
      networkStatus: {
        title: "Network Status",
        refresh: "Refresh",
        fetchError: "Error fetching network data",
        internetConnection: "Internet Connection",
        online: "Online",
        offline: "Offline",
        latency: "Latency",
        host: "Host",
        status: "Status",
        avgLatency: "Average Latency",
        minLatency: "Minimum Latency",
        maxLatency: "Maximum Latency",
        dnsStatus: "DNS Status",
        dnsWorking: "Working",
        dnsFailed: "Failed",
        resolveTime: "Resolve Time",
        activeConnections: "Active Connections",
        total: "Total",
        established: "Established",
        listening: "Listening",
        timeWait: "Time Wait",
        closeWait: "Close Wait",
        networkInterfaces: "Network Interfaces",
        noInterfaces: "No network interfaces found",
        up: "Active",
        down: "Inactive",
        mac: "MAC Address",
        speed: "Speed",
        received: "Received",
        sent: "Sent",
        errors: "Errors",
        dropped: "Dropped",
        lastUpdated: "Last updated"
      },
      activityLogs: {
        title: "Activity Logs",
        filter: "Filter",
        refresh: "Refresh",
        user: "User",
        action: "Action",
        description: "Description",
        entity: "Entity",
        timestamp: "Timestamp",
        details: "Details",
        viewDetails: "View details",
        noLogs: "No activity logs found",
        entityDetails: "Entity Details",
        filterTitle: "Filter Logs",
        startDate: "Start Date",
        endDate: "End Date",
        selectUser: "Select User",
        selectAction: "Select Action",
        apply: "Apply",
        clear: "Clear",
        cancel: "Cancel",
        logDetails: "Log Details",
        basicInfo: "Basic Information",
        ip: "IP",
        close: "Close"
      },
      systemUpdate: {
        title: "System Updates",
        checkUpdates: "Check for Updates",
        checkSuccess: "Update check completed successfully!",
        updateStatus: "Update Status",
        versionInfo: "Version Information",
        currentVersion: "Current Version",
        latestVersion: "Latest Version",
        updateAvailable: "Update Available",
        systemUpdated: "System Updated",
        upToDate: "Up to Date",
        lastChecked: "Last checked",
        releaseNotes: "Release Notes",
        installUpdate: "Install Update",
        backups: "Backups",
        restore: "Restore",
        noBackups: "No backups available",
        refreshBackups: "Refresh Backup List",
        confirmRestore: "Confirm Restore",
        restoreWarning: "Are you sure you want to restore this backup? This action will replace all current system data and cannot be undone.",
        confirmUpdate: "Confirm Update",
        updateWarning: "Are you sure you want to update the system? It is recommended to create a backup before continuing.",
        cancel: "Cancel",
        confirm: "Confirm",
        checking: "Checking for updates...",
        downloading: "Downloading update...",
        installing: "Installing update...",
        completed: "Update completed successfully!",
        error: "Update error",
        updateStarted: "Update process started!",
        restoreStarted: "Restore process started!",
        updateCompleted: "Update completed successfully!",
        updateError: "An error occurred during the update."
      },
      versionCheck: {
        title: "Version Check",
        checkUpdates: "Check for Updates",
        statusTitle: "System Version Status",
        currentVersion: "Your Version",
        latestVersion: "Latest Version",
        upToDate: "Your version is up to date",
        upToDateTitle: "Congratulations! System Updated",
        upToDateMessage: "Your system is running the latest available version. You are enjoying all the latest features and security fixes.",
        outdated: "Your version is outdated",
        latestAvailable: "Latest available version",
        updateAvailable: "Update Available",
        updateMessage: "A new system version is available. Contact the system administrator to request the update.",
        repositoryLink: "Project repository",
        repository: "GitHub",
        updateLink: "Automatic Updater",
        update: "Update Manual",
        success: "Version information updated successfully!",
        whatsappLibTitle: "WhatsApp Web JS Library Version",
        whatsappLibCurrentVersion: "Current Library Version",
        whatsappLibLatestVersion: "Latest Available Version",
        whatsappLibUpToDate: "Library up to date",
        whatsappLibOutdated: "Library outdated",
        whatsappLibLatestAvailable: "Latest available version",
        whatsappLibRepository: "View on GitHub",
        whatsappLibUpToDateTitle: "WhatsApp Web JS Library Updated",
        whatsappLibUpToDateMessage: "Your WhatsApp Web JS library is running the latest available version. You are enjoying all the latest features and security fixes.",
        whatsappLibUpdateAvailable: "Library Update Available",
        whatsappLibUpdateMessage: "A new version of the WhatsApp Web JS library is available."
      },
      backendErrors: {
        ERR_CREATING_MESSAGE: "Error creating message in the database.",
        ERR_CREATING_TICKET: "Error creating ticket in the database.",
        ERR_CONNECTION_CREATION_COUNT: "Channel limit reached, contact support to modify.",
        ERR_DELETE_WAPP_MSG: "Could not delete WhatsApp message.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_EDITING_WAPP_MSG: "Could not edit WhatsApp message.",
        ERR_FETCH_WAPP_MSG: "Error fetching message from WhatsApp, it may be too old.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_DEF_WAPP_FOUND: "No default WhatsApp found. Check the channels page.",
        ERR_NO_INTEGRATION_FOUND: "Integration not found.",
        ERR_NO_PERMISSION: "You do not have permission to access this resource.",
        ERR_NO_SETTING_FOUND: "No settings found with this ID.",
        ERR_NO_TAG_FOUND: "Tag not found.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No agent found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_NO_OTHER_WHATSAPP: "There must be at least one default WhatsApp.",
        ERR_OUT_OF_HOURS: "Out of operating hours!",
        ERR_OPEN_USER_TICKET: "There is already an open ticket for this contact with agent: ",
        ERR_OTHER_OPEN_TICKET: "There is already an open ticket for this contact.",
        ERR_NONE_USER_TICKET: "There is already an open ticket for this contact without an agent.",
        ERR_SESSION_EXPIRED: "Session expired. Please log in.",
        ERR_SENDING_WAPP_MSG: "Error sending WhatsApp message. Check the channels page.",
        ERR_SYNC_TAGS: "Error syncing tags.",
        ERR_USER_INACTIVE: "This agent is deactivated!",
        ERR_USER_TICKET_LIMIT: "Ticket limit reached for this agent.",
        ERR_USER_CREATION_COUNT: "Agent creation limit reached, contact support to modify.",
        ERR_USER_CREATION_DISABLED: "Agent creation has been disabled by the administrator.",
        ERR_WAPP_CHECK_CONTACT: "Could not verify WhatsApp contact. Check the channels page.",
        ERR_WAPP_DOWNLOAD_MEDIA: "Could not download media from WhatsApp. Check the channels page.",
        ERR_WAPP_GREETING_REQUIRED: "A greeting message is required when there is more than one sector.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid WhatsApp number.",
        ERR_WAPP_NOT_INITIALIZED: "This WhatsApp session has not been initialized. Check the channels page.",
        ERR_WAPP_SESSION_EXPIRED: "WhatsApp session expired.",
      },
    },
  },
};

export { messages };
